import { BigNumber } from 'bignumber.js';
import axios from 'axios';
import { tonChain } from './customChains';
import { tonWebProvider } from '../connectors/TonConnector';
import { toUserFriendlyAddress } from '@tonconnect/sdk';

interface ITonBalanceItem {
  balance: string;
  wallet_address: {
    address: string;
    is_scam: boolean;
    is_wallet: boolean;
  };
  jetton: {
    address: string;
    name: string;
    symbol: string;
    decimals: number;
    image: string;
    verification: string;
  };
}

interface IBalancesResponse {
  balances: ITonBalanceItem[];
}

type FetchBalanceArgs = {
  address: string;
  token: string;
};

const getWalletBalancesUrl = (address: string) =>
  `https://tonapi.io/v2/accounts/${address}/jettons`;

export const fetchTonBalance = async ({ address, token }: FetchBalanceArgs) => {
  try {
    if (!token) {
      const tonBalance = await tonWebProvider.getBalance(address);
      return BigNumber(tonBalance).div(10 ** tonChain.nativeCurrency.decimals);
    }
    const { data } = await axios.get<IBalancesResponse>(
      getWalletBalancesUrl(address)
    );
    const balance = data.balances.find(
      (b) => toUserFriendlyAddress(b.jetton.address) === token
    );
    if (balance) {
      return BigNumber(balance.balance).div(10 ** balance.jetton.decimals);
    }
    return BigNumber(0);
  } catch (error) {
    console.warn(error);
    return BigNumber(0);
  }
};
